import type { TranslationKeys } from '../types';

const id: TranslationKeys = {
  nav: {
    home: 'Beranda',
    blockExplorer: 'Penjelajah',
    swap: 'Tukar',
    exchange: 'Tukar lintas rantai',
    docs: 'Dokumentasi',
    more: 'Lainnya',
    close: 'Tutup',
    bridge: 'Jembatan',
  },
  bridge: {
    title: 'Jembatan Igra',
    subtitle: 'Jembatan KAS antara Kaspa dan Igra (rantai {chainId})',
    tabDeposit: 'Setor KAS',
    tabDepositSub: 'KAS → iKAS',
    tabWithdraw: 'Tarik KAS',
    tabWithdrawSub: 'iKAS → KAS',
    chainKaspa: 'Kaspa',
    chainEvm: 'EVM (Igra)',
    useWallet: 'Pakai dompet',
    gate: {
      installTitle: 'Hubungkan KasWare',
      installDesc:
        'Transaksi jembatan ditandatangani sepenuhnya di dalam KasWare. Pasang ekstensi atau buka halaman ini di aplikasi Telegram KasWare.',
      disconnectedTitle: 'Dompet terputus',
      connectWallet: 'Hubungkan dompet',
      connectTitle: 'Hubungkan {chain}',
      connectDesc: 'Otorisasi akun {chain} di KasWare untuk melanjutkan.',
      connecting: 'Menghubungkan...',
      connectChain: 'Hubungkan {chain}',
    },
    deposit: {
      youSend: 'Anda kirim (Kaspa L1)',
      youReceive: 'Anda terima (Igra L2)',
      recipientLabel: 'Terima iKAS di alamat Igra ini',
      fromWallet: '(dari dompet)',
      badAddress: 'Masukkan alamat EVM yang valid — alamat dengan huruf kapital harus lolos checksum EIP-55.',
      connectEvm: 'Hubungkan EVM untuk isi otomatis',
      connectingEvm: 'Menghubungkan EVM...',
      infoMin: 'Setoran minimum: {min} KAS.',
      infoMining:
        'ID transaksi ditambang di browser Anda agar diawali 97b1 — biasanya hanya butuh beberapa detik.',
      infoMint: 'iKAS dicetak setelah sequencer Igra mengonfirmasi Entry di Kaspa.',
      phaseConnecting: 'Menghubungkan ke jaringan Kaspa...',
      phaseFetching: 'Mengambil UTXO Anda...',
      phaseMining: 'Menambang ID transaksi yang valid... ({tries} percobaan)',
      phaseSigning: 'Menunggu tanda tangan Anda di KasWare...',
      phaseBroadcasting: 'Menyiarkan transaksi Entry...',
      cancelMining: 'Batalkan penambangan',
      successTitle: 'Setoran dikirim',
      successMined: 'ID transaksi valid ditemukan setelah {tries} percobaan (nonce {nonce}).',
      kaspaTx: 'Transaksi Kaspa:',
      prefixWarning:
        'ID transaksi yang disiarkan tidak lagi diawali 97b1. Igra mungkin tidak mengkredit setoran ini — simpan ID transaksinya dan hubungi dukungan.',
      newDeposit: 'Setor lagi',
      cta: 'Setor KAS ke Igra',
      ctaAmount: 'Setor {amount} KAS ke Igra',
    },
    withdraw: {
      youBurn: 'Anda bakar (Igra L2)',
      paidOut: 'Dibayarkan di (Kaspa L1)',
      payoutLabel: 'Alamat pembayaran KAS',
      infoLimits: 'Batas: {min} – {max} iKAS per penarikan.',
      infoFeeZero: 'Biaya protokol: saat ini 0.',
      infoFeeQuoted: 'Biaya protokol: dikutip saat diminta.',
      infoRate: '1 iKAS dibakar menjadi tepat 1 KAS pembayaran (tanpa selisih).',
      warningPrefix: 'Penarikan',
      warningStrong: 'tidak instan',
      warningRest:
        'iKAS dibakar di Igra, lalu komite multi-tanda tangan melepas KAS di Kaspa setelah meninjau permintaan. Hanya kirim jumlah yang siap Anda tunggu.',
      checking: 'Memeriksa...',
      modalTitle: 'Konfirmasi penarikan',
      modalBurn: 'Anda bakar',
      modalFee: 'Biaya protokol',
      modalPayout: 'KAS dibayarkan ke',
      modalAck:
        'Saya paham bahwa pencairan bersifat manual, ditinjau oleh komite multi-tanda tangan, dan tidak instan.',
      modalConfirm: 'Konfirmasi dan bakar iKAS',
      modalBack: 'Kembali',
      successTitle: 'Permintaan keluar dikonfirmasi di Igra',
      requestId: 'ID permintaan keluar: {id}',
      igraTx: 'Transaksi Igra:',
      successPayout: 'KAS akan dikirim ke:',
      successNote: 'KAS akan dilepas ke alamat pembayaran Anda setelah tinjauan multi-tanda tangan.',
      newWithdrawal: 'Tarik lagi',
      requesting: 'Meminta penarikan...',
      cta: 'Bakar iKAS dan minta KAS',
      ctaAmount: 'Bakar {amount} iKAS dan minta KAS',
    },
  },
  home: {
    tagline: 'KasWare Wallet',
    hero: {
      subtitle: 'Satu wallet self-custody untuk TON, Kaspa, dan rantai EVM — kunci Anda tetap di perangkat Anda.',
      chainsLabel: 'Jaringan yang didukung',
      ctaDownload: 'Tambahkan ke Chrome',
      ctaTelegram: 'Buka di Telegram',
      note: 'Gratis, tanpa pendaftaran, tanpa email.',
    },
    pillars: {
      security: {
        title: 'Aman sejak dirancang',
        desc: 'Kunci dibuat dan dienkripsi di perangkat Anda. Setiap transaksi diperiksa risikonya dan ditampilkan utuh sebelum ditandatangani.',
      },
      convenience: {
        title: 'Semua dalam satu tempat',
        desc: 'Simpan, kirim, tukar, dan bridge antara TON, Kaspa, dan EVM tanpa berganti-ganti wallet.',
      },
      friendly: {
        title: 'Dibuat untuk manusia',
        desc: 'Petunjuk berbahasa sederhana, alamat yang mudah dibaca, tema terang dan gelap, serta tujuh bahasa.',
      },
      reliable: {
        title: 'Bisa diandalkan',
        desc: 'Riwayat transaksi dapat diperiksa, beberapa endpoint jaringan, dan wallet tetap bisa dipakai saat satu penyedia bermasalah.',
      },
    },
    content: {
      downloadTitle: 'Unduh',
      securityTitle: 'Mengapa dana Anda tetap milik Anda',
      p1: 'KasWare adalah wallet self-custody untuk Ton, Kaspa, dan EVM.',
      p2: 'Kami tidak pernah memiliki akses ke dana Anda. Kunci pribadi Anda dienkripsi di perangkat Anda dengan kata sandi dan tidak pernah dibagikan kepada siapa pun.',
      p3: 'Semua akun diturunkan secara deterministik dari Frasa Pemulihan Rahasia Anda, memberikan kepemilikan dan kontrol penuh.',
    },
  },
  about: {
    contact: 'Hubungi Kami',
    contacts: {
      twitter: 'Twitter',
      telegram: 'Telegram',
      discord: 'Discord',
      email: 'Email',
    },
  },
  footer: {
    privacy: 'Kebijakan Privasi',
    copyright: 'Hak Cipta © {year} Flying Rabbit Tech Ltd',
  },
  explorer: {
    title: 'Penjelajah Transaksi',
    subtitle: 'Cari catatan transaksi Kaspa dan KRC-20 berdasarkan alamat',
    timeRange: 'Rentang Waktu:',
    to: 'ke',
    clear: 'Hapus',
    address: 'Alamat:',
    kasTab: 'Transfer KAS',
    krc20Tab: 'Operasi KRC-20',
    enterAddress: 'Masukkan alamat Kaspa untuk melihat transaksi',
    loading: 'Memuat...',
    search: {
      placeholder: 'Masukkan alamat Kaspa (kaspa:q...)',
      button: 'Cari',
    },
    tx: {
      loading: 'Memuat transaksi...',
      empty: 'Tidak ada transaksi yang ditemukan untuk alamat ini',
      emptyInRange: 'Tidak ada transaksi yang ditemukan untuk alamat ini dalam rentang waktu yang dipilih',
      failed: 'Gagal memuat transaksi: {error}',
      retry: 'Coba Lagi',
    },
    krc20: {
      loading: 'Memuat operasi KRC-20...',
      empty: 'Tidak ada operasi KRC-20 yang ditemukan untuk alamat ini',
      emptyInRange: 'Tidak ada operasi KRC-20 yang ditemukan untuk alamat ini dalam rentang waktu yang dipilih',
      failed: 'Gagal memuat operasi KRC-20: {error}',
      retry: 'Coba Lagi',
    },
  },
  languageNames: {
    en: 'EN',
    id: 'ID',
    fr: 'FR',
    zh_CN: '简体中文',
    zh_TW: '繁體中文',
    es: 'ES',
    th: 'TH',
  },
};

export default id;
